const exptlp = require('../../../assets/images/whyjio/experience/simplified-experience.png')
const exp3 = require('../../../assets/images/whyjio/experience/customize-logo-colors.png')
const exp1 = require('../../../assets/images/whyjio/experience/reduce-payment-friction.png')
const exp2 = require('../../../assets/images/whyjio/experience/solutions-to-needs.png')
const exp4 = require('../../../assets/images/whyjio/experience/accept-payment-ondemand.png')
const Conversionslp = require('../../../assets/images/whyjio/increase-conversion/scale-business.png')
const conver1 = require('../../../assets/images/whyjio/increase-conversion/jiopay-difference.png')
const conver2 = require('../../../assets/images/whyjio/increase-conversion/customer-choice-apps.png')
const conver3 = require('../../../assets/images/whyjio/increase-conversion/monitor-your-business.png')
const safelp = require('../../../assets/images/whyjio/mitigate-risk/privacy-safeguard.png')
const safe1 = require('../../../assets/images/whyjio/mitigate-risk/prevent-fraud-loss.png')
const safe3 = require('../../../assets/images/whyjio/mitigate-risk/keep-data-secure.png')
const preselp = require('../../../assets/images/whyjio/widen-presence/widen-your-presence.png')
const parse3 = require('../../../assets/images/whyjio/widen-presence/product-control.png')
const prese1 = require('../../../assets/images/whyjio/widen-presence/new-user-segment.png')
const prese2 = require('../../../assets/images/whyjio/widen-presence/jiopay-all-platform.png')

export const sectionData: any = {
  conversion: {
    header: 'Scale up your business. Drive Conversions. Lead the future.',
    subHeader: 'JioPay can help your business',
    checkList: [
      {
        image: null,
        text: 'Increase customer loyalty',
      },
      {
        image: null,
        text: 'Improve transaction success rates at the best cost',
      },
      {
        image: null,
        text: 'Offer the latest and popular payment modes',
      },
    ],
    buttonLeft: {
      title: 'Contact Us',
      goTo: 'navigate',
    },
    buttonRight: {
      title: 'Explore Direct',
      goTo: 'navigate',
    },
    lpImage: Conversionslp,
    contentMap: [
      {
        image: conver1,
        header: 'The JioPay difference',
        subheader: 'Integrate with JioPay and experience the benefits of innovation, scale and user experience.',
      },
      {
        image: conver2,
        header: 'Offer choice to customers',
        subheader:
          'Allow users to pay via any preferred payment modes. Set business preferences for payment modes and let your users pay using any of them.',
        coloredBgImage: true,
      },
      {
        image: conver3,
        header: 'Monitor your business',
        subheader: 'Powerful reports and end to end visibility of transactions to help you transform your business.',
      },
    ],
  },
  presence: {
    header: 'Expand your reach.\nGrow your business.',
    subHeader: 'JioPay can help you',
    checkList: [
      {
        image: null,
        text: 'Accelerate growth and achieve scale',
      },
      {
        image: null,
        text: 'Unlock opportunities with complementary features',
      },
      {
        image: null,
        text: 'Create seamless payment experiences with multiple payment options',
      },
    ],
    buttonLeft: {
      title: 'Contact Us',
      goTo: 'navigate',
    },
    lpImage: preselp,
    contentMap: [
      {
        image: prese1,
        header: 'Access new user segments',
        subheader: 'Reach new users with a single integration that lets you reach users of Jio and Jio Payments Bank',
      },
      {
        image: prese2,
        header: 'A world of opportunities',
        subheader:
          'Create custom journeys for your users either using our APIs or via our out of the box mobile first UI to create safe, friendly checkout experiences on JioPhones & Set-top boxes',
      },
      {
        image: parse3,
        header: 'Control your product experience',
        subheader:
          'Create the perfect experience that you would want your users to experience on your platform using JioPay.',
      },
    ],
  },
  secure: {
    header: 'Safeguarding your business. Securing your data.',
    subHeader: 'JioPay works real-time in mitigating safety risks and enables you to:',
    checkList: [
      {
        image: null,
        text: 'Secure user information',
      },
      {
        image: null,
        text: 'Shield from fraudulent transactions',
      },
      {
        image: null,
        text: 'Secure your business',
      },
    ],
    buttonLeft: {
      title: 'Contact Us',
      goTo: 'navigate',
    },
    lpImage: safelp,
    contentMap: [
      {
        image: safe1,
        header: 'Prevent fraud loss',
        subheader:
          'From basic fraud protection like risk thresholds and CVV checks to real-time pattern analysis, we always ensure your security',
      },
      {
        image: safe3,
        header: 'Keep your data secure',
        subheader:
          'As a certified PCI DSS service provider, JioPay lets you easily create a safe and secure checkout experience while offering multiple payment options',
      },
    ],
  },
  experience: {
    header: 'Keeping you focused\non your business. Creating delightful\nuser experiences',
    subHeader: 'JioPay can help you',
    checkList: [
      {
        image: null,
        text: 'Manage automatic repeat payments',
      },
      {
        image: null,
        text: 'Control payment collection dynamically',
      },
      {
        image: null,
        text: 'Store user information for future payments',
      },
      {
        image: null,
        text: 'Manage payouts to your merchant partners',
      },
    ],
    buttonLeft: {
      title: 'Contact Us',
      goTo: 'navigate',
    },
    lpImage: exptlp,
    contentMap: [
      {
        image: exp3,
        header: 'Design custom interfaces',
        subheader:
          'Create custom experience on your app or website. You can accept user payment information on your interface for a uniform experience irrespective of where your user uses you',
      },
      {
        image: exp1,
        header: 'Reduce payment friction',
        subheader:
          'Let users subscribe and pay periodically, pay with their saved data for fast, seamless transactions',
      },
      {
        image: exp4,
        header: 'Accept payments on-demand',
        subheader:
          'Use our product out of the box to start accepting scheduled or dynamic payments because your business shouldn’t have to wait',
      },
      {
        image: exp2,
        header: 'Solutions to solve your business needs',
        subheader:
          'Use the versatile products available on the JioPay platform to solve for your business problems with minimal effort',
      },
    ],
  },
}
